<template>
  <div class="overview">
    <Banner />

    <Headline>
      {{ downloads.headLine }}
    </Headline>

    <ContentBox :headline="downloads.content.box1.headLine" color="whitesmoke">
      <p>{{ downloads.content.box1.description }}</p>
    </ContentBox>

    <ContentBox :headline="downloads.content.box2.headLine" color="whitesmoke">
      <p>{{ downloads.content.box2.description }}</p>
      <div class="download-grid">
        <div
          class="download-card"
          v-for="platform in downloads.platforms"
          :key="platform.name"
        >
          <h4>{{ platform.name }}</h4>
          <p>Download for {{ platform.name }}</p>
          <a
            :href="platform.file"
            download
            class="download-button btn btn-outline-primary"
          >
            Download {{ platform.ext }}
          </a>
        </div>
      </div>
    </ContentBox>
  </div>
</template>

<script>
import Banner from "@/components/Banner.vue";
import Headline from "@/components/Headline.vue";
import ContentBox from "@/components/ContentBox.vue";

export default {
  name: "DownloadsPage",
  props: {
    metaProp: Object,
  },
  metaInfo() {
    return this.metaProp;
  },
  components: {
    Banner,
    Headline,
    ContentBox,
  },
  computed: {
    downloads() {
      return this.$store.state.data.downloads;
    },
  },
};
</script>

<style scoped>
.download-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.download-card {
  padding: 1rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #ffffff;
}

.download-button {
  display: inline-block;
  margin-top: 0.75rem;
  padding: 8px 12px !important;
  font-size: 12pt !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  text-decoration: none !important;
  border-color: rgb(0, 84, 159) !important;
  color: rgb(0, 84, 159) !important;
  background-color: transparent !important;
}

.download-button:hover {
  background-color: rgb(0, 84, 159) !important;
  color: white !important;
}

.download-button:focus {
  outline: none !important;
}
</style>
